var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Informations"},[_c('br'),_c('br'),_vm._v(" - Marcar el terreno "),_c('br'),_c('br'),_vm._v(" - Links de eventos "),_c('br'),_c('br'),_vm._v(" - Direcciones de sitios "),_c('br'),_c('br'),_vm._v(" - Canciones "),_c('br'),_c('br')])
}]

export { render, staticRenderFns }